import Vue from "vue";
import Vuex from "vuex";
import auth from "./modules/auth";
import settings from "./modules/settings";
import overrideUser from "./modules/overrideUser";

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

export default new Vuex.Store({
  modules: {
    auth,
    settings,
    overrideUser,
  },
  strict: debug,
});
